import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Paper,
  IconButton,
  CircularProgress,
  Button,
  Collapse,
  Tooltip
} from "@mui/material";
import Select from "react-select";
import Moment from "moment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReactSelect from "react-select";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
const MakePayment = (props) => {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const claimId = props.claimId;
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const paymentType = [
    { label: "Cash", value: "Cash" },
    { label: "Check", value: "Check" },
    { label: "Write off", value: "Write off" },
  ];

  const paymentSourseOption = [
    { label: "Patient", value: "Patient" },
    { label: "Carrier", value: "Carrier" },
    { label: "Provider", value: "Provider" },
  ];

  // ================= FETCH DATA =================
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (claimId > 0) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/PaymentById?claimId=${claimId}`,
          { headers },
        )
        .then((response) => {
          if (response) {
            setPaymentDetails(response);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [claimId]);
  const [diagnosisList, setDiagnosisList] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: field.code,
            value: field.id,
          });
        });
        setDiagnosisList(prac);
      })
      .catch((error) => {});
  }, [claimId]);

  const [checkSearchResults, setcheckSearchResults] = React.useState(false);
  const [checkNoData, setCheckNoData] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [checkSearchIndex, setcheckSearchIndex] = useState(null);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const highlightMatch = (text, search) => {
    if (!search) return text;

    const regex = new RegExp(`(${search})`, "ig");
    const parts = text.split(regex);

    return parts.map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            color: "#1976d2",
            fontWeight: 700,
            backgroundColor: "#e3f2fd",
            padding: "2px 4px",
            borderRadius: 4,
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const searchTimeout = React.useRef(null);
  const onChangeHandle = async (value, index) => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    if (!value.trim()) {
      setCheckNoData([]);
      setLoadingIndex(null);
      return;
    }

    searchTimeout.current = setTimeout(async () => {
      try {
        setLoadingIndex(index);

        const sendData = {
          id: 0,
          checkno: value,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/claims/SearchERA`,
          sendData,
          { headers },
        );

        setCheckNoData(response || []);
      } catch (error) {
        console.error("There was an error!", error);
        setCheckNoData([]);
      } finally {
        setLoadingIndex(null);
      }
    }, 400); // debounce
  };
  const saveData = () => {
    const postData = paymentDetails;
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addpayment`, postData, {
        headers,
      })
      .then((response) => {
        props.handleCloseMakePayment();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Payment saved successfully.",
          showConfirmButton: false,
          timer: 1500,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 5000;
          },
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while saving payment.",
          confirmButtonColor: "#1976d2",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 5000;
          },
        });
      });
  };
  const addNewPaymentRow = (index) => {
    const base = paymentDetails[index];

    const newRow = {
      id: 0,
      claimId: claimId,
      code: base.code,
      dosTo: base.dosTo,
      dxPointer1: base.dxPointer1,
      patientId: base.patientId,
      charges: 0,
      paymentType: "",
      paymentSourse: "",
      eRAId: 0,
      checkno: "",
      payer: "",
      checkdate: "",
      checkamount: 0,
      allowamount: 0,
      paidamount: 0,
      adjustmentamount: 0,
      writeoff: 0,
      writeOffReason: "",
      balance: 0,
    };

    const updated = [...paymentDetails];
    updated.splice(index + 1, 0, newRow);
    setPaymentDetails(updated);
  };
  const [expandedCheckIndex, setExpandedCheckIndex] = useState(null);
  const [Payers, setPayers] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsurance`, {
        headers,
      })
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: field.name,
            value: field.name,
          });
        });
        setPayers(prov);
      })
      .catch((error) => {});
  }, []);
  const [checkno, setcheckno] = useState("");
  const [payer, setpayer] = useState("");
  const [checkamount, setcheckamount] = useState("");
  const [checkdate, setcheckdate] = React.useState("");

  const saveInlineCheck = (index) => {
    let errors = [];

    if (!checkno || checkno.trim() === "") {
      errors.push("Please Add Check #");
    }

    if (!checkdate || checkdate.trim() === "") {
      errors.push("Please Select Date");
    }

    if (!payer) {
      errors.push("Payer is required");
    }

    if (!checkamount || checkamount === "") {
      errors.push("Check Amount is required");
    }

    // agar errors hain to SweetAlert me show karo
    if (errors.length > 0) {
      Swal.fire({
        title: "Validation Error",
        html: errors.map((err) => `• ${err}`).join("<br/>"),
        icon: "warning",
        confirmButtonText: "OK",
        heightAuto: false,
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-popup");
          const swalContainer = document.querySelector(".swal2-container");
          const swalBackdrop = document.querySelector(".swal2-backdrop");

          if (swalPopup) swalPopup.style.zIndex = "2800";
          if (swalContainer) swalContainer.style.zIndex = "2800";
          if (swalBackdrop) swalBackdrop.style.zIndex = "2799";
        },
      });
      return;
    }

    const postData = {
      checkno,
      payer,
      checkamount,
      checkdate,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/AddERA`, postData, {
        headers,
      })
      .then((response) => {
        const savedCheck = response;

        const updatedRows = [...paymentDetails];
        const checkRowIndex = updatedRows.findIndex(
          (row) => row.paymentType === "Check",
        );

        setSearchText(savedCheck.checkno);

        if (checkRowIndex !== -1) {
          updatedRows[checkRowIndex].eRAId = savedCheck.id;
          updatedRows[checkRowIndex].checkno = savedCheck.checkno;
          updatedRows[checkRowIndex].payer = savedCheck.payer;
          updatedRows[checkRowIndex].checkdate = savedCheck.checkdate
            ? Moment(savedCheck.checkdate).format("DD/MM/YYYY")
            : "";
          updatedRows[checkRowIndex].checkamount = savedCheck.checkamount;
        }

        setcheckno("");
        setpayer("");
        setcheckdate("");
        setcheckamount("");
        setExpandedCheckIndex(null);

        setPaymentDetails(updatedRows);
        Swal.fire({
          title: "Success!",
          text: "Record saved successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
          heightAuto: false,
        }).then(() => {});
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message || "Something went wrong.",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
          heightAuto: false,
        });
      });
  };
const completeAndCloseClaim = async () => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_API_URL}/claims/CloseClaim?claimId=${claimId}`,
      {},
      { headers }
    );
    if (res.success) {
      props.handleCloseMakePayment();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Payment saved and claim completed successfully.",
        showConfirmButton: false,
        timer: 1500,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 5000;
        },
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        error.response?.data?.message ||
        "Something went wrong while saving payment.",
      confirmButtonColor: "#1976d2",
      willOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = 5000;
      },
    });
  }
};
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 16px",
          background: "linear-gradient(70deg, #4facfe, #00f2fe)",
          color: "#fff",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left: Icon + Label */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <AccountBalanceIcon style={{ fontSize: 24 }} />
          <Typography
            variant="h6"
            component="span"
            style={{ fontWeight: "bold" }}
          >
            Make Payment
          </Typography>
        </div>

        <IconButton
          size="small"
          onClick={props.handleCloseMakePayment}
          sx={{
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.1)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
          }}
        >
          <CancelOutlinedIcon />
        </IconButton>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            width: "100%",
          }}
        >
          <CircularProgress size={40} />
        </div>
      ) : paymentDetails && paymentDetails.length > 0 ? (
        paymentDetails.map((row, index) => (
          <Paper
            key={index}
            variant="outlined"
            square
            sx={{
              p: 3,
              m: 2,
              borderRadius: "15px",
              background: row.id === 0 ? "#e8f5e9" : "#ffffff",
              border: row.id === 0 ? "2px solid #4caf50" : "1px solid #e0e0e0",
              boxShadow:
                row.id === 0
                  ? "0 8px 20px rgba(76,175,80,0.25)"
                  : "0 8px 20px rgba(0,0,0,0.08)",
            }}
          >
            <Grid container spacing={2}>
              {/* Procedure */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Procedure code:</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={row.code}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Diagnosis */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Diagnosis code:</Typography>
                <ReactSelect
                  isMulti
                  value={
                    row.dxPointer1
                      ? row.dxPointer1.split(",").map((code) => {
                          const found = diagnosisList.find(
                            (opt) => String(opt.value) === code.trim(),
                          );
                          return found || { label: code, value: code };
                        })
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const updated = [...paymentDetails];

                    const selectedValues = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];

                    updated[index].dxPointer1 = selectedValues.join(", ");

                    setPaymentDetails(updated);
                  }}
                  options={diagnosisList}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "99%",
                    }),
                  }}
                  isDisabled
                />
              </Grid>

              {/* DOS */}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>DOS</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={
                    row.dosTo ? Moment(row.dosTo).format("MM/DD/YYYY") : ""
                  }
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Charges */}
              {row.charges > 0 ? (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Typography>Charge $</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    value={row.charges}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={4} lg={3}></Grid>
              )}

              {/* Payment Type */}
              <Grid item xs={3}>
                <Typography>Payment Type:</Typography>

                <Select
                  options={paymentType}
                  placeholder="Payment Type"
                  value={
                    row.paymentType
                      ? paymentType.find(
                          (option) => option.value === row.paymentType,
                        )
                      : null
                  }
                  onChange={(selectedOption) => {
                    let updatedRows = [...paymentDetails];

                    updatedRows[index].paymentType = selectedOption.value;
                    setPaymentDetails(updatedRows);
                  }}
                />
              </Grid>

              {/* Payment Source */}
              <Grid item xs={3}>
                <Typography>Payment Source:</Typography>
                <Select
                  options={paymentSourseOption}
                  placeholder="Payment Sourse"
                  value={
                    row.paymentSourse
                      ? paymentSourseOption.find(
                          (option) => option.value === row.paymentSourse,
                        )
                      : null
                  }
                  onChange={(selectedOption) => {
                    let updatedRows = [...paymentDetails];
                    updatedRows[index].paymentSourse = selectedOption.value;
                    setPaymentDetails(updatedRows);
                  }}
                />
              </Grid>

              {row.paymentType == "Check" && (
                <>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        textDecoration: "underline",
                        mb: 0.5,
                      }}
                    >
                      Check Number:
                    </Typography>

                    <ClickAwayListener
                      onClickAway={() => {
                        setcheckSearchIndex(null);
                        setCheckNoData([]);
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <TextField
                          size="small"
                          autoComplete="off"
                          fullWidth
                          placeholder="Search Check Number"
                          value={
                            checkSearchIndex === index
                              ? searchText
                              : row.checkno || ""
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            setSearchText(val);
                            setcheckSearchIndex(index);
                            onChangeHandle(val, index);
                          }}
                          sx={{ backgroundColor: "#fff" }}
                          InputProps={{
                            endAdornment:
                              loadingIndex === index ? (
                                <CircularProgress size={18} />
                              ) : null,
                          }}
                        />

                        {checkSearchIndex === index && searchText && (
                          <div
                            style={{
                              position: "absolute",
                              top: "42px",
                              width: "100%",
                              maxHeight: 180,
                              overflowY: "auto",
                              background: "#fff",
                              border: "1px solid #c8e0ff",
                              borderRadius: 8,
                              boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                              zIndex: 1000,
                            }}
                          >
                            {loadingIndex === index ? (
                              <div
                                style={{
                                  padding: "12px",
                                  textAlign: "center",
                                  color: "#67748e",
                                  fontSize: 14,
                                }}
                              >
                                Searching…
                              </div>
                            ) : checkNoData.length > 0 ? (
                              checkNoData.map((item) => (
                                <div
                                  key={item.id}
                                  style={{
                                    padding: "10px 14px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                    fontWeight: 500,
                                    color: "#344767",
                                  }}
                                  onClick={() => {
                                    const rows = [...paymentDetails];

                                    rows[index] = {
                                      ...rows[index],
                                      eRAId: item.id,
                                      checkno: item.checkno,
                                      payer: item.payer,
                                      checkdate: item.checkdate,
                                      checkamount: item.checkamount,
                                    };

                                    setPaymentDetails(rows);
                                    setSearchText(item.checkno);
                                    setcheckSearchIndex(null);
                                    setCheckNoData([]);
                                  }}
                                >
                                  {highlightMatch(item.checkno, searchText)}
                                </div>
                              ))
                            ) : (
                              /* ✅ NO MATCH MESSAGE */
                              <div
                                style={{
                                  padding: "14px",
                                  textAlign: "center",
                                  color: "#d32f2f",
                                  fontWeight: 600,
                                  fontSize: 14,
                                }}
                              >
                                No matching check found
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </ClickAwayListener>
                  </Grid>
                </>
              )}
              {row.paymentType == "Check" && (
                <Grid item xs={2.5}>
                  <Typography
                    style={{
                      fontSize: "16px",
                      textDecoration: "underline",
                    }}
                  >
                    Payer:
                  </Typography>
                  <TextField
                    size="small"
                    placeholder="Payer..."
                    fullWidth
                    value={row.payer}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              )}
              {row.paymentType === "Check" && (
                <Grid item xs={1} >
                   <Tooltip
  title="Add New Check"
  arrow
  placement="top"
  componentsProps={{
    tooltip: {
      sx: {
        zIndex: 99999,
      },
    },
    popper: {
      sx: {
        zIndex: 99999,
      },
    },
  }}
>
                  <Button
                    onClick={() =>
                      setExpandedCheckIndex(
                        expandedCheckIndex === index ? null : index,
                      )
                    }
                    size="small"
                    sx={{
                  minWidth: "32px",
                  height: "32px",
                  marginTop:'20px',
                  borderRadius: "8px",
                  background:
                    expandedCheckIndex === index ? "#4facfe" : "#111827",
                  color: "#fff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    background:
                      expandedCheckIndex === index ? "#3b82f6" : "#1f2937",
                    transform: "translateY(-1px)",
                  },
                }}
                  >
                    <AddIcon sx={{ fontSize: 18 }} />
                  </Button>
                  </Tooltip>
                </Grid>
              )}
              {row.paymentType === "Check" && (
                <Collapse
                  in={expandedCheckIndex === index}
                  timeout={500}
                  easing={{
                    enter: "cubic-bezier(0.4, 0, 0.2, 1)",
                    exit: "cubic-bezier(0.4, 0, 1, 1)",
                  }}
                  unmountOnExit
                >
                  <Grid item xs={12}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        mt: 2,
                        borderRadius: "18px",
                        background: "rgba(255,255,255,0.9)",
                        backdropFilter: "blur(8px)",
                        border: "1px solid rgba(79,172,254,0.2)",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                        transform: "translateY(0px)",
                        transition: "all 0.35s ease",
                        animation: "fadeSlide 0.35s ease",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "15px",
                          mb: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          color: "#1976d2",
                        }}
                      >
                        🧾 Check Information
                        <span
                          style={{
                            fontSize: "11px",
                            background: "rgba(79,172,254,0.15)",
                            padding: "3px 10px",
                            borderRadius: "20px",
                            color: "#1976d2",
                            fontWeight: 600,
                          }}
                        >
                          Add New Check
                        </span>
                      </Typography>
                      <Grid container spacing={2}>
                        {/* Check No */}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{ fontSize: 12, mb: 0.5, color: "#666" }}
                          >
                            Check Number
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Enter check number"
                            fullWidth
                            value={checkno}
                            onChange={(e) => setcheckno(e.target.value)}
                            sx={{
                              background: "#fff",
                              borderRadius: "10px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                transition: "all 0.2s ease",
                                "&:hover fieldset": {
                                  borderColor: "#4facfe",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#00c6ff",
                                  boxShadow: "0 0 0 2px rgba(79,172,254,0.15)",
                                },
                              },
                            }}
                          />
                        </Grid>

                        {/* Payer */}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{ fontSize: 12, mb: 0.5, color: "#666" }}
                          >
                            Payer
                          </Typography>
                          <ReactSelect
                            value={Payers.find(
                              (option) => option.value == payer,
                            )}
                            onChange={(value) => setpayer(value.value)}
                            options={Payers}
                          styles={{
  control: (base, state) => ({
    ...base,
    height: "40px",
    minHeight: "40px",
    borderRadius: "10px",
    border: state.isFocused
      ? "1px solid #00c6ff"
      : "1px solid #e0e0e0",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(79,172,254,0.15)"
      : "none",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#4facfe",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    height: "40px",
    padding: "0 10px",
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "40px",
  }),

  menu: (base) => ({
    ...base,
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    maxHeight: "200px",
  }),

  menuList: (base) => ({
    ...base,
    maxHeight: "200px",
    padding: 0,
  }),
}}
                          />
                        </Grid>

                        {/* Date */}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{ fontSize: 12, mb: 0.5, color: "#666" }}
                          >
                            Check Date
                          </Typography>
                          <TextField
                            type="date"
                            size="small"
                            fullWidth
                            value={checkdate}
                            onChange={(e) => setcheckdate(e.target.value)}
                            sx={{
                              background: "#fff",
                              borderRadius: "10px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                transition: "all 0.2s ease",
                                "&:hover fieldset": {
                                  borderColor: "#4facfe",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#00c6ff",
                                  boxShadow: "0 0 0 2px rgba(79,172,254,0.15)",
                                },
                              },
                            }}
                          />
                        </Grid>

                        {/* Amount */}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{ fontSize: 12, mb: 0.5, color: "#666" }}
                          >
                            Check Amount
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Enter amount"
                            fullWidth
                            value={checkamount}
                            onChange={(e) => setcheckamount(e.target.value)}
                            sx={{
                              background: "#fff",
                              borderRadius: "10px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                transition: "all 0.2s ease",
                                "&:hover fieldset": {
                                  borderColor: "#4facfe",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#00c6ff",
                                  boxShadow: "0 0 0 2px rgba(79,172,254,0.15)",
                                },
                              },
                            }}
                          />
                        </Grid>

                        {/* Buttons */}
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                            mt: 1,
                          }}
                        >
                          <Button
                            variant="outlined"
                            sx={{
                              borderRadius: "10px",
                              textTransform: "none",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                transform: "translateY(-1px)",
                              },
                            }}
                            onClick={() => {
                              setcheckno("");
                              setpayer("");
                              setcheckdate("");
                              setcheckamount("");
                              setExpandedCheckIndex(null);
                            }}
                          >
                            Cancel
                          </Button>

                          <Button
                            variant="contained"
                            sx={{
                              borderRadius: "10px",
                              textTransform: "none",
                              background:
                                "linear-gradient(90deg, #4facfe, #00f2fe)",
                              boxShadow: "0 8px 20px rgba(79,172,254,0.3)",
                              transition: "all 0.2s ease",
                              "&:hover": {
                                transform: "translateY(-1px)",
                                boxShadow: "0 10px 25px rgba(79,172,254,0.4)",
                              },
                            }}
                            onClick={() => saveInlineCheck(index)}
                          >
                            Save Check
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Collapse>
              )}
              {row.paymentType == "Check" ? (
                <>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                    >
                      Check Date:
                    </Typography>
                    <TextField
                      size="small"
                      value={row.checkdate}
                      style={{ width: "99%" }}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      style={{
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                    >
                      Check Amount:
                    </Typography>
                    <TextField
                      size="small"
                      placeholder="Check amount..."
                      fullWidth
                      value={row.checkamount}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Allowed Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Allowed Amount"
                  fullWidth
                  value={row.allowamount}
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  onChange={(ev) => {
                    console.log("ee:", ev.target.value);
                    var _row = paymentDetails;
                    _row[index].allowamount = ev.target.value;

                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Paid Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Paid Amount"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.paidamount}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    var _row = paymentDetails;
                    _row[index].paidamount = value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);

                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Adjustment Amount</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Adjustment Amount"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.adjustmentamount}
                  onChange={(ev) => {
                    var _row = paymentDetails;

                    _row[index].adjustmentamount = ev.target.value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);
                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography>Write Off</Typography>

                <TextField
                  size="small"
                  placeholder="Enter Write off Amount Here"
                  fullWidth
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  value={row.writeoff}
                  onChange={(ev) => {
                    var _row = paymentDetails;
                    _row[index].writeoff = ev.target.value;
                    _row[index].balance =
                      Number(_row[index].charges || 0) -
                      Number(_row[index].writeoff || 0) -
                      Number(_row[index].adjustmentamount || 0) -
                      Number(_row[index].paidamount || 0);
                    setPaymentDetails([..._row]);
                  }}
                />
              </Grid>
              <Grid item xs={9}>
                <Typography>WriteOff Reason</Typography>

                <TextField
                  size="small"
                  fullWidth
                    value={row.writeOffReason || ""}
                  sx={{
                    backgroundColor: "#fff",
                  }}
                  onChange={(ev) => {
    const updatedDetails = [...paymentDetails];
    updatedDetails[index].writeOffReason = ev.target.value;   
    setPaymentDetails(updatedDetails);
  }}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography>Balance</Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={Number(Number(row.balance || 0).toFixed(2))}
                  onChange={(ev) => {
                    console.log("ee:", ev.target.value);
                    var _row = paymentDetails;
                    setPaymentDetails([..._row]);
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            <Grid
  item
  xs={12}
  sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}
>
  {/* Add New Payment Row — hidden when row.id == 0 */}
  {row.id !== 0 && (
    <Button
      variant="gradient"
      onClick={() => addNewPaymentRow(index)}
      style={{
        height: "40px",
        color: "white",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "none",
        gap: "8px",
        background: "linear-gradient(135deg, #667eea, #764ba2)",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(102,126,234,0.4)",
      }}
    >
      Add New Payment Row
    </Button>
  )}

  {/* NEW: Complete and Close Claim */}
 <Button
  variant="contained"
  sx={{
    background: "linear-gradient(70deg, #10b981, #22c55e)",
    padding: "10px 25px",
    borderRadius: "10px",
    height: "40px",
    color: "white",
    fontSize: "14px",
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(16,185,129,0.4)",
  }}
  onClick={completeAndCloseClaim}
>
  Complete and Close Claim
</Button>
  {/* Save Payment */}
  <Button
    variant="contained"
    sx={{
      background: "linear-gradient(70deg, #4facfe, #00f2fe)",
      padding: "10px 25px",
      borderRadius: "10px",
      height: "40px",
      color: "white",
      fontSize: "14px",
      textTransform: "none",
    }}
    onClick={saveData}
    disabled={paymentDetails.length < 0}
  >
    Save Payment
  </Button>
</Grid>
            </Grid>
          </Paper>
        ))
      ) : (
        <Typography
          style={{
            textAlign: "center",
            padding: "20px",
            color: "#999",
          }}
        >
          No Record Found
        </Typography>
      )}
    </>
  );
};

export default MakePayment;
